import { TypographyVariants } from '../Typography/types';
import { minHeight40, minHeight48, py11 } from './styles';
import { InputAdornmentEnum, InputShape, InputSize } from './types';

type InputAdornmentSpacingConfigType = {
  [size in InputSize]: {
    [shape in InputShape]: {
      [adornment in InputAdornmentEnum]: {
        input?: string;
        inputMultiline?: string;
        multiline?: string;
        root?: string;
      };
    };
  };
};

export const INPUT_ADORNMENT_SPACING_CONFIG: InputAdornmentSpacingConfigType = {
  large: {
    pill: {
      [InputAdornmentEnum.Both]: {
        multiline: py11,
        root: 'ps-20 pe-16',
      },
      [InputAdornmentEnum.End]: {
        input: 'ps-20',
        multiline: py11,
        root: 'pe-16',
      },
      [InputAdornmentEnum.None]: {
        input: 'ps-20 pe-16',
        inputMultiline: py11,
      },
      [InputAdornmentEnum.Start]: {
        input: 'pe-16',
        multiline: py11,
        root: 'ps-20',
      },
    },
    square: {
      [InputAdornmentEnum.Both]: {
        multiline: py11,
        root: 'px-12',
      },
      [InputAdornmentEnum.End]: {
        input: 'ps-16',
        multiline: py11,
        root: 'pe-12',
      },
      [InputAdornmentEnum.None]: {
        input: 'px-16',
        inputMultiline: py11,
      },
      [InputAdornmentEnum.Start]: {
        input: 'pe-16',
        multiline: py11,
        root: 'ps-12',
      },
    },
  },
  medium: {
    pill: {
      [InputAdornmentEnum.Both]: {
        multiline: 'py-8',
        root: 'px-16',
      },
      [InputAdornmentEnum.End]: {
        input: 'ps-16',
        multiline: 'py-8',
        root: 'pe-16',
      },
      [InputAdornmentEnum.None]: {
        input: 'px-16',
        inputMultiline: 'py-8',
      },
      [InputAdornmentEnum.Start]: {
        input: 'pe-16',
        multiline: 'py-8',
        root: 'ps-16',
      },
    },
    square: {
      [InputAdornmentEnum.Both]: {
        multiline: 'py-8',
        root: 'px-12',
      },
      [InputAdornmentEnum.End]: {
        input: 'ps-16',
        multiline: 'py-8',
        root: 'pe-12',
      },
      [InputAdornmentEnum.None]: {
        input: 'px-16',
        inputMultiline: 'py-8',
      },
      [InputAdornmentEnum.Start]: {
        input: 'pe-16',
        multiline: 'py-8',
        root: 'ps-12',
      },
    },
  },
};

export const INPUT_SHAPE_CLASSES = {
  pill: 'rounded-full',
  square: 'rounded-8',
};

export const INPUT_SIZE_CLASSES = {
  large: minHeight48,
  medium: minHeight40,
};

export const DEFAULT_INPUT_TYPOGRAPHY_VARIANT = {
  large: 'body-short-01' as TypographyVariants,
  medium: 'body-short-02' as TypographyVariants,
};

export const INPUT_APPEARANCE_CLASSES = {
  filled:
    'border border-solid bg-bg-tertiary border-transparent hover:bg-field focus-within:bg-field hover:focus-within:bg-field',
  outline:
    'border border-solid bg-bg-primary border-field hover:border-border-dark focus-within:border-focus-primary hover:focus-within:border-focus-primary',
};

export const INPUT_DISABLED_CLASSES = {
  filled: '',
  outline: 'bg-bg-secondary',
};
